import '../styles/style.scss';
import {v4 as uuidv4} from "uuid";
import { Outlet, useLocation } from 'react-router-dom';
import { useStoreCtx } from '../store';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from "swiper/modules";
import 'swiper/css';
import { useEffect, useState } from 'react';
import {getClientID, getDiscountPercent, translateMultiPeriod, tvhEnvironmentApi} from '../util/helpers';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import { Subscription } from '../util/promo';

export const IndexView = observer(() => {
	const httpService = useStoreCtx().appStore
	const sessionId = uuidv4()
	const location = useLocation()

	useEffect(() => {
		console.log('location', location.pathname);
		httpService.clearSessionSaveOldValues(
			window.sessionStorage.getItem("request_id"),
			window.sessionStorage.getItem("analyticsQuery"),
			window.sessionStorage.getItem("subscription_period"),
		)
		if (location.pathname === '/') {
			const intervalId = setInterval(() => {
				if (getClientID()) {
					clearInterval(intervalId)
					httpService.pushEvent()
				}
			}, 500)
		} else if (location.pathname === '/ssoauth') {
			const intervalId = setInterval(() => {
				if (httpService.grclientid) {
					clearInterval(intervalId)
					httpService.pushEvent()
				}
			}, 500)
		}
	}, [])

	function webSsoAuth(subscription?: Subscription) {
		httpService.pushEvent({
			event: "landing_button_click",
			event_name: "landing_button_click",
			buttonId: "activate",
			buttonText: "Подключить",
			field_text: subscription?.promotion.period === 3 ? "3month" : subscription?.promotion.period === 6 ? "6month" : "12month"
		})

		if (!subscription) {
			window.sessionStorage.removeItem("subscription_period")
		} else {
			httpService.selectedSubscription = subscription;
			window.sessionStorage.setItem("subscription_period", subscription.promotion.timeToLiveValue.toString())
		}

		window.sessionStorage.setItem("request_id", uuidv4())
		httpService.pushEvent({
		  event: 'authorization_start',
		  event_name: 'authorization_start',
		  referer: '',
		  auth_method: "sms",
		  auth_type: 'websso',
		  request_id: window.sessionStorage.getItem("request_id")
		})

		const hostUrl = window.location.host
		window.location.assign(
		  encodeURI(
			  `https://${tvhEnvironmentApi}/tvh-public-api-gateway/public/rest/general/websso/redirect?state=${sessionId}&clientType=WEB&domain=${hostUrl}`
		  )
		);
	}

	const postersFirst = [
		{ img: 'images/images-block/main-3.png' },
		{ img: 'images/images-block/main.png' },
		{ img: 'images/images-block/main-4.png' },
		{ img: 'images/images-block/main-1.png' },
		{ img: 'images/images-block/main-6.png' },
		{ img: 'images/images-block/main-13.png' },
		{ img: 'images/images-block/main-5.png' },
	];

	const postersSecond = [
		{ img: 'images/images-block/main-9.png' },
		{ img: 'images/images-block/main-10.png' },
		{ img: 'images/images-block/main-7.png' },
		{ img: 'images/images-block/main-11.png' },
		{ img: 'images/images-block/main-8.png' },
		{ img: 'images/images-block/main-12.png' },
		{ img: 'images/images-block/main-14.png' },
	];

	const newItems = [
		{ img: 'images/new-items/newItem1.png' },
		{ img: 'images/new-items/newItem2.png' },
		{ img: 'images/new-items/newItem3.png' },
		{ img: 'images/new-items/newItem4.png' },
		{ img: 'images/new-items/newItem5.png' },
		{ img: 'images/new-items/newItem6.png' },
	];

	const [isAnalyticsQuery, setIsAnalyticsQuery] = useState<boolean>(false);
	const [subscriptions, setSubscriptions] = useState<Subscription[]>([]);

	useEffect(() => {
		const queryParams = location.search;

		if (queryParams.includes('utm_source')) {
			setIsAnalyticsQuery(true);
			setSubscriptions(httpService.subscriptions);
		} else {
			setIsAnalyticsQuery(false);
			setSubscriptions(httpService.subscriptionsWithoutQuery);
		}
	}, []);

	useEffect(() => {
		if (!httpService.accessToken) return;
		const fetchActiveSub = async () => await httpService.fetchActiveSubscription();
		fetchActiveSub();
	}, [httpService.accessToken])

	return (
		<>
        	<Outlet/>

			<header className="header">
				<div className="wrapper">
					<a className="logo" href="https://kion.ru/"><svg width="138" height="44" viewBox="0 0 280 59" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 58.3223V0H18.7464V22.9956L33.577 0H54.1564L34.91 28.4946L54.1564 58.3223H32.2439L18.7464 36.0765V58.3223H0ZM56.9059 58.3223V0H75.6523V32.7438L93.7322 0H114.395V58.3223H95.6485V25.5785L77.5686 58.3223H56.9059ZM221.875 58.3223V0H240.621V20.4128H261.034V0H279.78V58.3223H261.034V37.9095H240.621V58.3223H221.875ZM140.64 39.9924H195.63V18.3299H140.64V39.9924ZM121.06 58.3223V0H215.209V58.3223H121.06Z" fill="white"/></svg></a>
				</div>
			</header>

			<div className="f_screen">
				<div className="text">
					<h1>
						КИОН - твой онлайн-кинотеатр
					</h1>
				</div>
				<div className="tariffs">
					<h2>Выбери свою подписку</h2>
					<div className="tariff_block">
						{subscriptions.map((sub, index) => (
								<div className="tariff">
									<div className="period">{sub.promotion.period}</div>
									{index > 0 && <div className="percent_discount">{getDiscountPercent(subscriptions[0].discountPrice / 100, sub.discountPrice / 100 / sub.promotion.period)}%</div>}
									<div className="price_block">
										<div className="discount_price">{Math.ceil(sub.discountPrice / 100 / sub.promotion.period)} ₽<br/><span>за месяц</span></div>
									</div>
									<div className="button-container">
										<div className="full_price">{
											sub.promotion.period === 1 ?
												"Оплата ежемесячно" :
												<>При оплате <span>{sub.price / 100}₽</span> ₽ {translateMultiPeriod(sub.promotion.period + "MULTIMONTH")}</>}</div>
										<button 
											onClick={() => {
												if (httpService.activeSubscription?.productId === sub.productId) return;
												webSsoAuth(sub);
											}}
											className={clsx('btn', httpService.activeSubscription?.productId === sub.productId && 'disabled-button')}
										>
											{httpService.activeSubscription?.productId === sub.productId ? 'Вы уже подписаны' : 'Подключить'}
										</button>
									</div>
								</div>
							))}
						</div>
				</div>
				<img src="images/images-block/main-image.png"/>
			</div>

			<div className="main-content">
				<div className="swiper-block">
					<div className="sb-header">
						<h2>Подключи подписку и начни смотреть&nbsp;уже&nbsp;сейчас</h2>
					</div>
					<div className="images">
						<div className="images-content">
							{postersFirst.length && (
								<Swiper 
									className="sample-slider" 
									modules={[Autoplay]}
									slidesPerView={'auto'} 
									autoplay={{ delay: 0 }} 
									speed={8000} 
									loop={true}
								>
									{postersFirst.map((poster, idx) => (
										<SwiperSlide key={idx} className="img-block">
											<img src={poster.img} />
										</SwiperSlide>
									))}
								</Swiper>
							)}

							{postersSecond.length && (
								<Swiper 
									className="sample-slider" 
									modules={[Autoplay]}
									slidesPerView={'auto'}
									autoplay={{ delay: 0, reverseDirection: true }} 
									initialSlide={1} 
									speed={8000} 
									loop={true}
								>
									{postersSecond.map((poster, idx) => (
										<SwiperSlide key={idx} className="img-block">
											<img src={poster.img} />
										</SwiperSlide>
									))}
								</Swiper>
							)}
						</div>
					</div>
				</div>

				<div className="economy_block">
					<div className="new_items_block">
						<h3>Новинки каждую неделю</h3>
						<div className="new_items">
							{newItems.map((item) => (
								<div className='image_container'><img src={item.img} /></div>
							))}
						</div>
					</div>

					<div className="tiles">
						<div className="big_tile">
							<h3>Фильмы и сериалы, доступные только на Кион</h3>
							<div className="img-block-tile">
								<img className="img1" src="images/kion-films.png"/>
								<img className="img2" src="images/kion-films2.png"/>
								<img className="img3" src="images/kion-films3.png"/>
							</div>
						</div>
						<div className="right_tiles">
							<div className="small_tile">
								<h3>200+ ТВ каналов</h3>
								<img className="img2" src="images/200-tv.png"/>
							</div>
							<div className="small_tile">
								<h3>Умная система рекомендаций</h3>
								<img className="img3" src="images/smart-system-recomm.png"/>
							</div>
						</div>
					</div>
				</div>

				<div className="footer">
					<div className="text">
						<p>
							© 2026 ООО «КИОН». Все права защищены. 12+
						</p>
						<p>
							* Специальные цены действительны при подключении новых клиентов (не имеющих на момент подключения действующей подписки КИОН) по акции
							на сайте <a href="https://standalone.kion.ru">standalone.kion.ru</a> с 01.09.2026 г. по 30.11.2026 г. (включительно). Организатор акции вправе менять условия и период проведения акции. Пользовательское соглашение: <a href="https://kion.ru/user-agreement">https://kion.ru/user-agreement</a>
						</p>
						<p>
							** Для всех пользователей: «КИОН» на 3 месяца – 399 р., далее автопродление - 699 р. на 3 месяца, «КИОН» на 6 месяцев – 699 р., далее автопродление - 1190 р. на 6 месяцев, «КИОН» на 1 год – 999 р., далее автопродление - 1990 р. в год.
						</p>
					</div>
				</div>				
			</div>
		</>
	);
})